module.exports = __webpack_public_path__ + "static/img/2.caa8299.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/eng/2.png
// module id = JBXE
// module chunks = 0